import { AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { ABodyProps } from '../../atoms/ABody/ABody.types';
import type { HTMLAttributes } from 'react';

export enum MTextBlockBasicAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MTextBlockBasicAEyebrowProps extends Partial<AEyebrowProps> {}

export interface MTextBlockBasicASubheaderProps extends Partial<ASubheaderProps> {
  text: string;
}

export interface MTextBlockBasicABodyProps extends Partial<ABodyProps> {
  bodyText: string;
}

export interface MTextBlockBasicProps extends HTMLAttributes<HTMLDivElement> {
  alignment?: MTextBlockBasicAlignment;
  aEyebrow?: MTextBlockBasicAEyebrowProps;
  aSubheader?: MTextBlockBasicASubheaderProps;
  aBody?: MTextBlockBasicABodyProps;
}
